<template>
  <div>
    <PackageItemRequirementsModal
      v-bind="{ packageItem, updating }"
      v-on="{ submit: doUpdatePackageItem }"
    />
  </div>
</template>

<script>
import PackageItemRequirementsModal from '@/components/PackageItem/RequirementsModal.vue';
import { packageItemComputed, packageItemMethods } from '@/store/adminHelper';

export default {
  name: 'PackageItemRequirements',
  components: {
    PackageItemRequirementsModal,
  },
  data: () => ({
    updating: false,
  }),
  computed: {
    ...packageItemComputed,
  },
  methods: {
    ...packageItemMethods,
    doUpdatePackageItem(updateData) {
      this.updating = true;
      const { id: packageItemId } = this.packageItem;
      this.updatePackageItem({ packageItemId, updateData })
        .then(() => {
          this.updating = false;
          this.redirectToPackageItem();
        })
        .catch(() => {
          this.updating = false;
        });
    },
    redirectToPackageItem() {
      this.$router.go(-1);
    },
  },
};
</script>
